export default __webpack_public_path__ + "static/media/ParentsGuidetoCubs.faf2a73a.pdf";